/**
 * Action types for the voicemail feature.
 */
// Inbox operations
export const VOICEMAIL_INBOX_LOADED = 'VOICEMAIL_INBOX_LOADED';
export const VOICEMAIL_INBOX_LOADING = 'VOICEMAIL_INBOX_LOADING';
export const VOICEMAIL_MESSAGE_SELECTED = 'VOICEMAIL_MESSAGE_SELECTED';
export const VOICEMAIL_MESSAGE_DELETED = 'VOICEMAIL_MESSAGE_DELETED';
export const VOICEMAIL_MESSAGE_SEEN = 'VOICEMAIL_MESSAGE_SEEN';
export const VOICEMAIL_UNREAD_COUNT_UPDATED = 'VOICEMAIL_UNREAD_COUNT_UPDATED';
// Recording lifecycle
export const VOICEMAIL_CAPTURE_REQUESTED = 'VOICEMAIL_CAPTURE_REQUESTED';
export const VOICEMAIL_RECORDING_STARTED = 'VOICEMAIL_RECORDING_STARTED';
export const VOICEMAIL_RECORDING_COMPLETE = 'VOICEMAIL_RECORDING_COMPLETE';
export const VOICEMAIL_RECORDING_CANCELLED = 'VOICEMAIL_RECORDING_CANCELLED';
export const VOICEMAIL_RECORDING_SENT = 'VOICEMAIL_RECORDING_SENT';
// UI state
export const VOICEMAIL_PROMPT_SHOWN = 'VOICEMAIL_PROMPT_SHOWN';
export const VOICEMAIL_PROMPT_DISMISSED = 'VOICEMAIL_PROMPT_DISMISSED';
export const VOICEMAIL_PLAYER_OPENED = 'VOICEMAIL_PLAYER_OPENED';
export const VOICEMAIL_PLAYER_CLOSED = 'VOICEMAIL_PLAYER_CLOSED';
// Errors
export const VOICEMAIL_ERROR = 'VOICEMAIL_ERROR';
export const VOICEMAIL_CLEAR_ERROR = 'VOICEMAIL_CLEAR_ERROR';
